import { render, staticRenderFns } from "./PortalHeader.vue?vue&type=template&id=7483fbc4&scoped=true&"
import script from "./PortalHeader.vue?vue&type=script&lang=js&"
export * from "./PortalHeader.vue?vue&type=script&lang=js&"
import style0 from "./PortalHeader.vue?vue&type=style&index=0&id=7483fbc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7483fbc4",
  null
  
)

export default component.exports